import styled from 'styled-components';
import React, { FC, memo } from 'react';
import { PaymentPlanSkeletonProps } from './models';
import * as styles from './styles';
import sunbitLogoWhite from '../../../../assets/sunbit-logo-white.svg';
import { Skeleton } from '../../../skeleton/Skeleton';

export const PaymentPlanSkeleton = styled<FC<PaymentPlanSkeletonProps>>(
  memo(({ className, isLoading }) => (
    <Skeleton {...{ isLoading, className }}>
      <div className="content">
        <img className="logo-placeholder" src={sunbitLogoWhite} />
        <p className="text">
          <span className="currency-wrapper">
            <span className="currency">$</span>0
          </span>
          <span className="separator">/</span>mo
        </p>
      </div>
    </Skeleton>
  ))
)`
  ${styles.PaymentPlanSkeleton}
`;
